import { configureStore } from "@reduxjs/toolkit";
import ProductReducer from ".././features/product/slices/Product";
import AdInsertReducer from ".././features/adInsert/slices/AdInsert";
import NotificationReducer from ".././features/notification/slices/Notification";
import CurrentUserInformationSlice, {
  setValue,
} from "../shared/slice/CurrentUser.slice";
export type RootState = ReturnType<typeof store.getState>;

const reducer = {
  product: ProductReducer,
  adInsert: AdInsertReducer,
  notification: NotificationReducer,
  currentUser: CurrentUserInformationSlice,

};

const store = configureStore({
  reducer: reducer,
  devTools: true,
});
export default store;
export const resetStore = () => {

  // Dispatch reset actions for other slices here...
};
